import { DARK_BLUE } from '../theme/color';

export const overrides = {
    MuiDialogTitle: {
        root: {
            '& .NeptuneDialogTitle-close path': {
                fill: DARK_BLUE
            },
            '& .NeptuneDialogTitle-close:hover path': {
                fill: DARK_BLUE
            }
        }
    }
};
